import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'omni-common-ui';
import { actions as practicePlayActions } from 'data/PracticePlay';
import { actions as GroupMembers } from 'data/GroupMembers';
import CourseViewTable from 'components/CourseViewTable';
import is from 'is_js';

export class PracticePlay extends PureComponent {
  componentWillMount() {
    this._fetchPracticePlayIfNeeded(this.props);
  }

  componentWillReceiveProps(props) {
    this._fetchPracticePlayIfNeeded(props);
  }

  _fetchPracticePlayIfNeeded(props = this.props) {
    this.props.fetchPracticePlayIfNeeded(props.groupId);
  }

  render() {
    const { members, practicePlayContent } = this.props;
    if (! practicePlayContent || practicePlayContent.size === 0 || members.size === 0) return null;

    return <CourseViewTable students={members}>
      <CourseViewTable.Header>
        <CourseViewTable.Row>
          <CourseViewTable.Cell columnId={{ column: 'completion' }} small>
            Activities Completion
          </CourseViewTable.Cell>
          <CourseViewTable.Cell columnId={{ column: 'completedOn' }} small>
            Last Activities Completed On
          </CourseViewTable.Cell>
        </CourseViewTable.Row>
      </CourseViewTable.Header>
      <CourseViewTable.Body>
        {
          (member, { column }) => {
            const practicePlay = practicePlayContent.find((content) =>
                content.studentId === member.studentGeneralInfo.id);

            if (column === 'completion') {
              const completion = practicePlay && is.existy(practicePlay.activitiesCompleted) ?
                  `${practicePlay.activitiesCompleted}/${practicePlay.activitiesAmount}` : 'N/A';
              return completion;
            }

            const completedOn = practicePlay && practicePlay.lastActivitiesCompletedDate ?
                practicePlay.lastActivitiesCompletedDate.format('YYYY-MM-DD') : 'N/A';
            return completedOn;
          }
        }
      </CourseViewTable.Body>
    </CourseViewTable>;
  }
}

PracticePlay.propTypes = {
  groupId: PropTypes.string.isRequired,
  members: PropTypes.shape.isRequired,
  practicePlayContent: PropTypes.shape,
  fetchPracticePlayIfNeeded: PropTypes.func.isRequired,
};

function mapStateToProps(state, ownProps) {
  const { groupId } = ownProps.params;
  const members = GroupMembers.getMembersByGroup(state, groupId);
  const practicePlayContent = state.get('rootReducer').get('practicePlay').get(groupId);
  return { groupId, members, practicePlayContent };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(practicePlayActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PracticePlay);



// WEBPACK FOOTER //
// ./containers/Group/Homework/PracticePlay/component.jsx